module.exports = __webpack_public_path__ + "img/06-04_Acting Confidently.3b4c1a1c.svg";